/* eslint-disable */
import Helper from "../../common/Helper";
import CharaBase from "../../common/CharaBase";

class CharaLandscape extends CharaBase {
  constructor(scene) {
    super(scene);
  }

  //------------------------------------
  // Setup Mesh
  //------------------------------------
  setupMeshs() {
    //Mesh Setting
    this.mesh = BABYLON.MeshBuilder.CreateCylinder(
      "CharaLandscape",
      { height: 0.01, diameter: 5, tessellation: 64 },
      this.scene
    );

    this.mesh.material = new BABYLON.PBRMetallicRoughnessMaterial(
      "CharaLandscape",
      this.scene
    );

    this.mesh.material.baseColor = new BABYLON.Color3(0.25, 0.25, 0.25);
    this.mesh.material.visibility = 0.5;
    this.mesh.material.metallic = 0.5;
    this.mesh.material.roughness = 0.5;

    this.mesh.animations = [];
    this.mesh.animations.push(this.createMoveAnimation("scaling.x"));
    this.mesh.animations.push(this.createMoveAnimation("scaling.z"));
    this.mesh.animations.push(this.createAlphaAnimation("visibility"));

    this.mesh.position.y = -0.25;
  }

  //create animation
  createMoveAnimation(prop) {
    let keys = [];

    keys.push({
      frame: 0,
      value: 1
    });

    keys.push({
      frame: 30,
      value: 15
    });

    let animationBox = new BABYLON.Animation(
      this.mesh.id,
      prop,
      30,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
    );

    animationBox.setKeys(keys);

    return animationBox;
  }

  //create animation
  createAlphaAnimation(prop) {
    let keys = [];

    keys.push({
      frame: 0,
      value: 1
    });

    keys.push({
      frame: 25,
      value: 1
    });

    keys.push({
      frame: 30,
      value: 0
    });

    let animationBox = new BABYLON.Animation(
      this.mesh.id,
      prop,
      30,
      BABYLON.Animation.ANIMATIONTYPE_FLOAT,
      BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
    );

    animationBox.setKeys(keys);

    return animationBox;
  }

  startAnimation() {
    this.scene.beginAnimation(this.mesh, 0, 30, true);
  }

  backAnimation() {
    this.scene.beginAnimation(this.mesh, 30, 0, true);
  }
}
export default CharaLandscape;
